import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, PlusCircle, MessageCircle, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { Badge } from '../ui/badge';

const MobileBottomNav = ({ unreadCount = 0 }) => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();
  const { t } = useLanguage();
  
  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const navItems = [
    { path: '/', icon: Home, key: 'home', label: t('nav.home') },
    { path: '/search', icon: Search, key: 'search', label: t('nav.search') },
    { path: '/create-listing', icon: PlusCircle, key: 'sell', label: t('nav.sell'), isCreate: true },
    { path: '/messages', icon: MessageCircle, key: 'messages', label: t('nav.messages'), badge: unreadCount },
    { path: isAuthenticated ? '/profile' : '/login', icon: User, key: isAuthenticated ? 'profile' : 'login', label: isAuthenticated ? t('nav.profile') : t('nav.login') },
  ];

  return (
    <nav 
      className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 safe-area-bottom"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          if (item.isCreate) {
            return (
              <Link
                key={item.path}
                to={item.path}
                className="flex flex-col items-center justify-center -mt-4"
                data-testid="mobile-nav-sell"
              >
                <div className="w-14 h-14 rounded-full bg-emerald-600 flex items-center justify-center shadow-lg">
                  <Icon className="h-7 w-7 text-white" />
                </div>
              </Link>
            );
          }
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 py-2 relative ${
                active ? 'text-emerald-600' : 'text-gray-500'
              }`}
              data-testid={`mobile-nav-${item.key}`}
            >
              <div className="relative">
                <Icon className={`h-6 w-6 ${active ? 'stroke-[2.5px]' : ''}`} />
                {item.badge > 0 && (
                  <Badge 
                    className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 bg-red-500 text-white text-xs"
                  >
                    {item.badge > 9 ? '9+' : item.badge}
                  </Badge>
                )}
              </div>
              <span className={`text-xs mt-1 ${active ? 'font-medium' : ''}`}>
                {item.label}
              </span>
              {active && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-emerald-600 rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
